import {
    IEtapa,
    IVincularDesvincularAcaoEtapa,
} from "../../../Interfaces/Geral/Etapas/EtapasInterfaces";
import { ACESSOS } from "../../../Routes/Acessos";
import {
    AtualizarEtapaService,
    AtualizarOrdemEtapaService,
    DeletarEtapaService,
    DesvincularGrupoAcaoService,
    DesvincularEtapaGrupoDinamicaService,
    DesvincularEtapaGrupoFixaService,
    GetEtapaService,
    InserirEtapaService,
    ListarCategoriaTipoCasoService,
    ListarEtapasDesvinculadasGrupoService,
    ListarEtapasPorCategoriaAtendimentoETipoCasoService,
    ListarEtapasPorCategoriaETipoCasoService,
    ListarEtapasService,
    ListarEtapasVinculadasGrupoService,
    ListarGrupoDesvinculadosPorEtapaService,
    ListarGrupoNaoVinculadosPorEtapaFixaService,
    ListarGrupoVinculadosPorEtapaFixaService,
    ListarGrupoVinculadosPorEtapaService,
    VincularGrupoAcaoService,
    VincularEtapaGrupoDinamicaService,
    VincularEtapaGrupoFixaService,
    ListarEtapasPorCategoriaAtendimentoOuTipoCasoService,
} from "../../../Services/Geral/Etapas/EtapasServices";

import { Controller } from "../../Controller";
import { TIPO_CASO } from "../../../Constants/Geral/TipoCaso";

export async function ListarEtapasController(
    idTipoCaso: number,
    idCategoria: number | number[]
) {
    return Controller(ListarEtapasService(idTipoCaso, idCategoria));
}

export async function ListarEtapasPorCategoriaETipoCasoController(
    ID_TIPO_CASO: number,
    ID_CATEGORIA_ATENDIMENTO: number | number[]
) {
    return Controller(
        ListarEtapasPorCategoriaETipoCasoService(
            ID_TIPO_CASO,
            ID_CATEGORIA_ATENDIMENTO
        )
    );
}

export async function ListarEtapasAtendimentoAoClienteController(
    idCategoria: number | number[]
) {
    if (idCategoria)
        return ListarEtapasController(
            ACESSOS.ATENDIMENTO.ID_MODULO,
            idCategoria
        );
    else return [];
}
export async function ListarEtapasAssistenciaTecnicaController(
    idCategoria: number
) {
    return ListarEtapasController(ACESSOS.ASSISTENCIA.ID_MODULO, idCategoria);
}

export async function ListarEtapasVendasController(idCategoria: number) {
    return ListarEtapasController(ACESSOS.VENDAS.ID_MODULO, idCategoria);
}

export async function ListarEtapasRepasseController(idCategoria: number) {
    return ListarEtapasController(ACESSOS.REPASSE.ID_MODULO, idCategoria);
}

export async function ListarEtapasEntregaDeChavesController() {
    return ListarEtapasController(TIPO_CASO.VISTORIA.ID_TIPO_CASO, 0);
}

export async function InserirEtapaController(requestBody: IEtapa) {
    return Controller(InserirEtapaService(requestBody));
}

export async function DeletarEtapaController(
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number
) {
    return Controller(
        DeletarEtapaService(ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO),
        "Etapa deletada com sucesso!"
    );
}

export async function AtualizarEtapaController(requestBody: Partial<IEtapa>) {
    return Controller(AtualizarEtapaService(requestBody));
}

export async function VincularEtapaGrupoDinamicaController(
    idGrupo: number,
    idEtapaCategoriaAtendimentoTipoCaso: number
) {
    return Controller(
        VincularEtapaGrupoDinamicaService(
            idGrupo,
            idEtapaCategoriaAtendimentoTipoCaso
        )
    );
}

export async function VincularEtapaGrupoFixaController(
    idGrupo: number,
    idEtapaTipoCaso: number
) {
    return Controller(VincularEtapaGrupoFixaService(idGrupo, idEtapaTipoCaso));
}

export async function DesvincularEtapaGrupoDinamicaCotroller(
    idEtapaCategoriaAtendimentoTipoCasoGrupo: number
) {
    return Controller(
        DesvincularEtapaGrupoDinamicaService(
            idEtapaCategoriaAtendimentoTipoCasoGrupo
        ),
        "Etapa desvinculada ao grupo com sucesso!"
    );
}

export async function DesvincularEtapaGrupoFixaController(
    idEtapaTipoCasoGrupo: number
) {
    return Controller(DesvincularEtapaGrupoFixaService(idEtapaTipoCasoGrupo));
}

export async function GetEtapaController(
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number
) {
    return Controller(
        GetEtapaService(ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO)
    );
}

export async function ListarGrupoVinculadosPorEtapaController(
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number
) {
    return Controller(
        ListarGrupoVinculadosPorEtapaService(
            ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
        )
    );
}

export async function ListarGrupoVinculadosPorEtapaFixaController(
    idEtapaTipoCaso: number
) {
    return Controller(
        ListarGrupoVinculadosPorEtapaFixaService(idEtapaTipoCaso)
    );
}

export async function ListarGrupoDesvinculadosPorEtapaController(
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number
) {
    return Controller(
        ListarGrupoDesvinculadosPorEtapaService(
            ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
        )
    );
}

export async function ListarGrupoNaoVinculadosPorEtapaFixaController(
    idEtapaTipoCaso: number
) {
    return Controller(
        ListarGrupoNaoVinculadosPorEtapaFixaService(idEtapaTipoCaso)
    );
}

export async function AtualizarOrdemEtapaController(
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO: number,
    NR_ETAPA_DESTINO: number
) {
    return Controller(
        AtualizarOrdemEtapaService(
            ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO,
            NR_ETAPA_DESTINO
        )
    );
}

export const ListarEtapasCategoriaRepasseController = async () =>
    ListarEtapasController(ACESSOS.REPASSE.ID_MODULO, 0);

export async function ListarEtapasPorTipoCasoController(idTipoCaso: number) {
    return Controller(ListarEtapasService(idTipoCaso, 0));
}

export async function ListarEtapasDesvinculadasGrupoController(
    idGrupo: number,
    idCategoriaAtendimento: number,
    idTipoCaso: number
) {
    return Controller(
        ListarEtapasDesvinculadasGrupoService(
            idGrupo,
            idCategoriaAtendimento,
            idTipoCaso
        )
    );
}

export async function ListarEtapasVinculadasGrupoController(
    idGrupo: number,
    idCategoriaAtendimento: number,
    idTipoCaso: number
) {
    return Controller(
        ListarEtapasVinculadasGrupoService(
            idGrupo,
            idCategoriaAtendimento,
            idTipoCaso
        )
    );
}

export async function ListarCategoriaTipoCasoController(idTipoCaso: number) {
    return Controller(ListarCategoriaTipoCasoService(idTipoCaso));
}

export async function ListarEtapasPorCategoriaAtendimentoETipoCasoController(
    idCaso: number,
    idTipoCaso?: number
) {
    return Controller(
        ListarEtapasPorCategoriaAtendimentoETipoCasoService(idCaso, idTipoCaso)
    );
}

export async function ListarEtapasPorCategoriaAtendimentoOuTipoCasoController(
    idTipoCaso: number
) {
    return Controller(
        ListarEtapasPorCategoriaAtendimentoOuTipoCasoService(idTipoCaso)
    );
}

export async function VincularGrupoAcaoController(
    requestBody: IVincularDesvincularAcaoEtapa
) {
    return Controller(VincularGrupoAcaoService(requestBody));
}

export async function DesvincularGrupoAcaoController(
    ID_GRUPO: number,
    ID_ACAO: number
) {
    return Controller(DesvincularGrupoAcaoService(ID_GRUPO, ID_ACAO));
}
